import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notesService } from '../api/notes.service';
import { NOTE_KEYS } from './queryKeys';
import type { NoteFormValues } from '../schemas';

/**
 * Notes mutations. All invalidate the broad `NOTE_KEYS.all` prefix (covers the
 * sidebar's infinite list, the open note's detail, and its history) instead of
 * narrow keys — same "invalidate the broad key" rule used by `useTagMutations`.
 */
export function useCreateNote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: NoteFormValues) => notesService.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: NOTE_KEYS.all });
    },
  });
}

/** Also used for autosave — every call creates a new history entry on the backend. */
export function useUpdateNote(noteId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: NoteFormValues) => notesService.update(noteId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: NOTE_KEYS.all });
    },
  });
}

export function useDeleteNote() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (noteId: string) => notesService.delete(noteId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: NOTE_KEYS.all });
    },
  });
}
